export default [{
                              fontFamily: 'Inter-Light',
                              file: require('/Users/saimirgora/Desktop/tsnew/appConfigs/base/fonts/Inter-Light.ttf'),
                          },{
                              fontFamily: 'AntDesign',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/AntDesign.ttf'),
                          },{
                              fontFamily: 'Entypo',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/Entypo.ttf'),
                          },{
                              fontFamily: 'EvilIcons',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/EvilIcons.ttf'),
                          },{
                              fontFamily: 'Feather',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/Feather.ttf'),
                          },{
                              fontFamily: 'FontAwesome',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/FontAwesome.ttf'),
                          },{
                              fontFamily: 'FontAwesome5_Brands',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/FontAwesome5_Brands.ttf'),
                          },{
                              fontFamily: 'FontAwesome5_Regular',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/FontAwesome5_Regular.ttf'),
                          },{
                              fontFamily: 'FontAwesome5_Solid',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/FontAwesome5_Solid.ttf'),
                          },{
                              fontFamily: 'Fontisto',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/Fontisto.ttf'),
                          },{
                              fontFamily: 'Foundation',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/Foundation.ttf'),
                          },{
                              fontFamily: 'Ionicons',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/Ionicons.ttf'),
                          },{
                              fontFamily: 'MaterialCommunityIcons',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf'),
                          },{
                              fontFamily: 'MaterialIcons',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/MaterialIcons.ttf'),
                          },{
                              fontFamily: 'Octicons',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/Octicons.ttf'),
                          },{
                              fontFamily: 'SimpleLineIcons',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/SimpleLineIcons.ttf'),
                          },{
                              fontFamily: 'Zocial',
                              file: require('/Users/saimirgora/Desktop/tsnew/node_modules/react-native-vector-icons/Fonts/Zocial.ttf'),
                          },];